import React from 'react';
import WorkspaceName from './WorkspaceName';
import WorkspaceAvatar from './WorkspaceAvatar';

export default function WorkspaceGeneralSettingsPanel() {
  return (
    <>
      <WorkspaceAvatar />
      <WorkspaceName />
    </>
  );
}
